// @flow

import React from 'react'
import type { Node } from 'react'
import styled from 'styled-components'

const List = styled.ul`
  list-style: none;
  padding-left: 0;
`

type Props = {
  children: Node,
}
const Navigation = ({ children }: Props) => (
  <nav>
    <List className="flex">{children}</List>
  </nav>
)

export default Navigation



// WEBPACK FOOTER //
// ./src/components/navigation/navigation.js